module.exports = __webpack_public_path__ + "media/img/event/speakers/sueann-headshot-fc7c4ff202d4e32a84f5a9c3edc2c3d9.png";